import { isChartId } from 'charts/catalog/chartCatalog';
import { useIsOffline } from 'components/common/withIsOffline';
import { useAppNavigation } from 'contexts/navigation';
import useIsMobile from 'hooks/useIsMobile';
import React, { ReactElement, useCallback } from 'react';
import { useChartRuntime } from 'charts/hooks/useChartRuntime';
import { FiltersRenderer } from '../filtersRenderer/index';
import { MemoChartDetailsPresentational } from './presentational';
import type { ChartDetailsContainerProps } from './types';

function ChartDetails({ id }: ChartDetailsContainerProps): ReactElement {
  const isMobile = useIsMobile();
  const isOffline = useIsOffline();
  const { goToAnalytics } = useAppNavigation();
  const context = useChartRuntime(id);
  const updatedAt = context?.updatedAt();

  const forceReload = useCallback(() => {
    context?.forceUpdate?.();
  }, [context]);

  if (!isChartId(id) || !context) {
    goToAnalytics();
    return <></>;
  }

  return (
    <MemoChartDetailsPresentational
      chartId={id}
      context={context}
      isMobile={isMobile}
      isOffline={isOffline}
      updatedAt={updatedAt}
      onRefresh={forceReload}
      filtersRenderer={<FiltersRenderer id={id} />}
    />
  );
}

export const MemoChartDetails = React.memo(ChartDetails);
